var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 7.53147H6.11079V16.9759H3.33301V7.53147ZM4.71356 6.42036H4.69801C3.86912 6.42036 3.33301 5.80258 3.33301 5.03091C3.33301 4.24258 3.88579 3.64258 4.72967 3.64258C5.57467 3.64258 6.09523 4.24258 6.11079 5.03091C6.11079 5.80202 5.57467 6.42036 4.71356 6.42036ZM16.6663 16.9759H13.8886V11.9209C13.8886 10.6998 13.208 9.86647 12.1152 9.86647C11.2813 9.86647 10.8302 10.4287 10.6113 10.972C10.5313 11.1665 10.5552 11.7042 10.5552 11.9759V16.9759H7.77745V7.53147H10.5552V8.9848C10.9558 8.3648 11.583 7.53147 13.1875 7.53147C15.1752 7.53147 16.6658 8.78147 16.6658 11.5726L16.6663 16.9759Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0348de0e7c79d222694d0a7c661e019c.svg";
export { ForwardRef as ReactComponent };